<template>
  <div>
    <h1 class="h2 mt-4">KOCKÁZATI INFORMÁCIÓK SZAKASZ</h1>
    <div class="form-group">
      Kérjük jelölje mely tevékenységekre szeretné a fedezetet kiterjeszteni:
      <br /><br />
      <div class="form-check mb-2">
        <ValidationProvider name="design_buildings" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="design_buildings"
            v-model="design_buildings"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="design_buildings"
          :value="design_buildings ? 1 : 0"
        />
        <label for="design_buildings" class="form-check-label">
          <b>
            Építészeti-műszaki tervezési tevékenység
          </b>
        </label>
        &nbsp;
        <span
          class="info"
          id="design_buildings-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?</span
        >
      </div>
      <!-- <div class="form-check mb-2">
        <ValidationProvider name="design_machine" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="design_machine"
            v-model="design_machine"
          />
        </ValidationProvider>
        <input v-show="false" name="design_machine" :value="design_machine ? 1 : 0" />
        <label for="design_machine" class="form-check-label">
          <b>
            Építménynek nem minősülő gépek, berendezések tervezése
          </b>
        </label>
      </div> -->
      <div class="form-check mb-2">
        <ValidationProvider name="prof_engineer" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="prof_engineer"
            v-model="prof_engineer"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="prof_engineer"
          :value="prof_engineer ? 1 : 0"
        />
        <label for="prof_engineer" class="form-check-label">
          <b>Szakági mérnöki tevékenység</b><br />
          <!-- <span>Szakági mérnöki tevékenység alatt az alábbi tevékenységek értendők:</span> -->
        </label>
        <!-- <span
          class="info"
          id="design_machine-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
        >
          ?</span
        > -->
        <div>
          Szakági mérnöki tevékenység alatt az alábbi tevékenységek értendők:
        </div>
        <ul>
          <li>Villamosmérnöki tevékenység</li>
          <li>Elektromérnöki tevékenység</li>
          <li>Egészségügyi-műszaki tervezés / mérnöki tevékenység</li>
          <li>Elektrotechnikai tervezés / mérnöki tevékenység</li>
          <li>Geodéziai és Geoinformatikai tervezés / mérnöki tevékenység</li>
          <li>Környezetvédelmi tervezés / mérnöki tevékenység</li>
          <li>Közlekedés mérnöki tevékenység</li>
          <li>Munkabiztonsági tervezés / mérnöki tevékenység</li>
          <li>Tűzvédelmi tervezés / mérnöki tevékenység, szakértés</li>
          <li>Mérnöki tanácsadás /szakértői tevékenység</li>

          <!-- <div>
            <input
              type="checkbox"
              class="form-check-input mb-2"
              id="prof_engineer_other"
              v-model="prof_engineer_other"
            />
            <input v-show="false" name="prof_engineer_other" :value="prof_engineer_other ? 1 : 0" />
            <label for="prof_engineer_other" class="form-check-label">
              Ha a cég által végzett szakági mérnöki tevékenység nem tartozik a fenti listába,
              kérjük, adja meg itt: <br />
            </label>
            <ValidationProvider
              v-if="prof_engineer_other"
              name="prof_engineer_other_type"
              rules="required"
              :immediate="true"
              v-slot="{errors}"
            >
              <input
                class="form-control"
                id="prof_engineer_other_type"
                name="prof_engineer_other_type"
                v-model="prof_engineer_other_type"
              />

              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div> -->
        </ul>
      </div>
      <!-- <div>
        <input
          type="checkbox"
          class="form-check-input mb-2"
          id="prof_engineer_other"
          v-model="prof_engineer_other"
        />
        <input v-show="false" name="prof_engineer_other" :value="prof_engineer_other ? 1 : 0" />
        <label for="prof_engineer_other" class="form-check-label">
          <b>Egyéb mérnöki tevékenység: <br /> </b>
        </label>
        <input
          v-if="prof_engineer_other"
          class="form-control"
          id="prof_engineer_other_type"
          name="prof_engineer_other_type"
          v-model="prof_engineer_other_type"
        />
      </div> -->
      <div v-show="false" class="input-group">
        <label class="col-2" for="detailed_engineer">detailed_engineer: </label>
        <input
          class="form-control col-2"
          id="detailed_engineer"
          name="detailed_engineer"
          v-model="getDetailedEngineerChosen"
          readonly
        />
        <!-- <small class="text-danger input-alert">{{ errors[0] }}</small> -->
      </div>
      <!-- </ValidationProvider> -->
      <div v-if="design_buildings || prof_engineer" class="form-group row mb-3">
        <label class="col-sm-4 mb-2" for="selected_teaor">
          Kérjük jelölje, ha az alábbi tevékenységek közül bármelyiket is végzi:
          <span class="text-danger">*</span>
        </label>
        <div class="ms-3">
          <ValidationProvider
            name="detailed_engineer_chosen"
            rules="required"
            :immediate="true"
            v-slot="{ errors }"
          >
            <input
              v-show="false"
              type="checkbox"
              class="form-check-input"
              id="IsDetailedEngineerChosen"
              v-model="IsDetailedEngineerChosen"
            />
            <small class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
          <div class="form-check mb-2">
            <ValidationProvider
              name="detailed_engineer_statement"
              rules=""
              :immediate="true"
            >
              <input
                type="checkbox"
                class="form-check-input"
                id="detailed_engineer_statement"
                v-model="detailed_engineer_statement"
              />
            </ValidationProvider>
            <input
              v-show="false"
              name="detailed_engineer_statement"
              :value="detailed_engineer_statement ? 1 : 0"
            />
            <label for="detailed_engineer_statement" class="form-check-label">
              <b>
                Az alábbiak közül egyiket sem végzem
              </b>
            </label>
          </div>
          <div v-for="(item, id) in detailed_engineer" :key="id">
            <input
              type="checkbox"
              :id="id"
              :disabled="detailed_engineer_statement"
              :checked="
                isDetailedEngineerChecked('detailed_engineer_checked', id)
              "
              @change="
                updateCheckeddDtailedEngineer(
                  'detailed_engineer_checked',
                  id,
                  $event.target.checked
                )
              "
            />
            <label class="mx-3" :for="'detailed_engineer' + id">{{
              item
            }}</label>
          </div>
        </div>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider
          name="technical_inspection"
          rules=""
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="technical_inspection"
            v-model="technical_inspection"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="technical_inspection"
          :value="technical_inspection ? 1 : 0"
        />
        <label for="technical_inspection" class="form-check-label">
          <b>
            Műszaki ellenőri tevékenység
          </b>
        </label>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider name="legal_expert" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="legal_expert"
            v-model="legal_expert"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="legal_expert"
          :value="legal_expert ? 1 : 0"
        />
        <label for="legal_expert" class="form-check-label">
          <b>
            Igazságügyi szakértői tevékenység
          </b>
        </label>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="certify_audit"
            v-model="certify_audit"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="certify_audit"
          :value="certify_audit ? 1 : 0"
        />
        <label for="certify_audit" class="form-check-label">
          <b>
            Energetikai tanúsító / auditori tevékenység
          </b>
        </label>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider name="design_inspector" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="design_inspector"
            v-model="design_inspector"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="design_inspector"
          :value="design_inspector ? 1 : 0"
        />
        <label for="design_inspector" class="form-check-label">
          <b>
            Tervezői művezetés / Tervellenőri tevékenység
          </b>
        </label>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider name="techn_management" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="techn_management"
            v-model="techn_management"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="techn_management"
          :value="techn_management ? 1 : 0"
        />
        <label for="techn_management" class="form-check-label">
          <b>
            Felelős műszaki vezetői tevékenység
          </b>
        </label>
      </div>
      <div class="form-check mb-2">
        <ValidationProvider
          name="investment_manager"
          rules=""
          :immediate="true"
        >
          <input
            type="checkbox"
            class="form-check-input"
            id="investment_manager"
            v-model="investment_manager"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="investment_manager"
          :value="investment_manager ? 1 : 0"
        />
        <label for="investment_manager" class="form-check-label">
          <b>
            Beruházáslebonyolítói tevékenység / Mérnök koordinációs tevékenység
          </b>
        </label>
      </div>
      <ValidationProvider
        name="professional_activity"
        rules="required"
        :immediate="true"
        v-slot="{ errors }"
      >
        <input
          v-show="false"
          type="checkbox"
          class="form-check-input"
          id="IsProfessionalActivityChosen"
          v-model="IsProfessionalActivityChosen"
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>

      <!-- <div v-if="investment_manager" class="form-group row mb-3">
        <label class="col-sm-4 mb-2" for="selected_teaor">
          Kérjük jelölje a nyújtott szakmai tevékenységeket! (min. 1):
          <span class="text-danger">*</span>
        </label>
        <div class="input-group">
          <label v-show="false" class="col-2" for="detailed_manager">detailed_manager: </label>
          <ValidationProvider
            name="detailed_manager"
            rules="required"
            :immediate="true"
            v-slot="{errors}"
          >
            <input
              v-show="false"
              class="form-control col-2"
              id="detailed_manager"
              name="detailed_manager"
              v-model="getDetailedManagerChosen"
              readonly
            />
            <small class="text-danger input-alert">{{ errors[0] }}</small>
          </ValidationProvider>
        </div>
        <div>
          <div class="form-check" v-for="(item, id) in detailed_manager" :key="id">
            <input
              type="checkbox"
              class="form-check-input"
              :id="id"
              :checked="isDetailedEngineerChecked('detailed_manager_checked', id)"
              @change="
                updateCheckeddDtailedEngineer('detailed_manager_checked', id, $event.target.checked)
              "
            />
            <label class="mx-3" :for="'detailed_manager' + id">{{ item }}</label>
          </div>
        </div>
      </div> -->
      <br /><br />

      <!-- tevékenységek ettől -->
      <!-- <div>
        <b class="mb-2">
          Kérjük nyilatkozni, hogy az alábbi projektek esetében nyújtanak-e bármilyen szakmai
          tevékenységet?
        </b>
      </div>
      <ValidationProvider
        name="detailed_project_chosen"
        rules="required"
        :immediate="true"
        v-slot="{errors}"
      >
        <input
          v-show="false"
          type="checkbox"
          class="form-check-input"
          id="IsDetailedProjectChosen"
          v-model="IsDetailedProjectChosen"
        />
        <small class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>

      <ValidationProvider :immediate="true" rules="">
        <div v-show="false" class="input-group">
          <label class="col-2" for="detailed_project">detailed_project data: </label>
          <input
            class="form-control col-2"
            id="detailed_project"
            name="detailed_project"
            v-model="getDetailedProjectChosen"
            readonly
          />
        </div>
      </ValidationProvider>
      <div class="form-check mb-2">
        <ValidationProvider name="detailed_project_statement" rules="" :immediate="true">
          <input
            type="checkbox"
            class="form-check-input"
            id="detailed_project_statement"
            v-model="detailed_project_statement"
          />
        </ValidationProvider>
        <input
          v-show="false"
          name="detailed_project_statement"
          :value="detailed_project_statement ? 1 : 0"
        />
        <label for="detailed_project_statement" class="form-check-label">
          <b>
            Nem végzek szakmai tevékenységet a felsoroltak közül.
          </b>
        </label>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4 mb-2" for="selected_teaor">
          Kérjük jelölje a nyújtott szakmai tevékenységeket!:
        </label>
        <div class="ms-3">
          <div v-for="(item, id) in detailed_project" :key="id">
            <input
              type="checkbox"
              :id="id"
              :checked="isDetailedEngineerChecked('detailed_project_checked', id)"
              @change="
                updateCheckeddDtailedEngineer('detailed_project_checked', id, $event.target.checked)
              "
              :disabled="detailed_project_statement"
            />
            <label class="mx-3" :for="'detailed_project' + id">{{ item }}</label>
          </div>
        </div>
      </div> -->
      <!--tevékenységek eddig  -->
    </div>
    <div class="row mb-3">
      <b>Kérjük az alábbi kérdések megválaszolását:</b>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Végeznek-e bármilyen jellegű kivitelezési tevékenységet?
        <span class="text-danger">*</span>&nbsp;</label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="construction"
            :value="1"
            v-model="construction"
          />
          <label class="form-check-label" for="allandoan_lakott_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="construction"
            :value="0"
            v-model="construction"
          />
          <label class="form-check-label" for="allandoan_lakott_nem">
            Nem
          </label>
        </div>
      </div>

      <ValidationProvider
        v-show="false"
        :immediate="true"
        rules="required"
        class="col-sm-8"
      >
        <input
          id="construction"
          class="form-check-input"
          type="radio"
          v-model="construction"
        />
      </ValidationProvider>
    </div>
    <!-- <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Gyárt-e bármilyen terméket?<span class="text-danger">*</span>&nbsp;</label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="manufacture"
            :value="1"
            v-model="manufacture"
          />
          <label class="form-check-label" for="manufacture">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="manufacture"
            :value="0"
            v-model="manufacture"
          />
          <label class="form-check-label" for="manufacture">
            Nem
          </label>
        </div>
      </div>
      <ValidationProvider v-show="false" :immediate="true" rules="required" class="col-sm-8">
        <input id="manufacture" class="form-check-input" type="radio" v-model="manufacture" />
      </ValidationProvider>
    </div> -->
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Megfelel a vonatkozó törvény szerinti szakmagyakorlási engedélyben
        foglaltaknak?<span class="text-danger">*</span>&nbsp;</label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="legal_compliance"
            :value="1"
            v-model="legal_compliance"
          />
          <label class="form-check-label" for="legal_compliance">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="legal_compliance"
            :value="0"
            v-model="legal_compliance"
          />
          <label class="form-check-label" for="legal_compliance">
            Nem
          </label>
        </div>
      </div>
      <ValidationProvider
        v-show="false"
        :immediate="true"
        rules="required"
        class="col-sm-8"
      >
        <input
          id="legal_compliance"
          class="form-check-input"
          type="radio"
          v-model="legal_compliance"
        />
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Érvényesítettek-e valaha a szakmai szolgáltatásukkal összefüggésben
        bármilyen kárigényt a társasággal/biztosítottal szemben?<span
          class="text-danger"
          >*</span
        >&nbsp;
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="claim_history"
            :value="1"
            v-model="claim_history"
          />
          <label class="form-check-label" for="claim_history">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="claim_history"
            :value="0"
            v-model="claim_history"
          />
          <label class="form-check-label" for="claim_history">
            Nem
          </label>
        </div>
      </div>
      <ValidationProvider
        v-show="false"
        :immediate="true"
        rules="required"
        class="col-sm-8"
      >
        <input
          id="claim_history"
          class="form-check-input"
          type="radio"
          v-model="claim_history"
        />
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Van-e tudomása olyan körülményről vagy esetről, amely a társasággal /
        biztosítottal szemben érvényesített kárigényhez vezethet, amire a
        megkötésre kerülő biztosítás fedezetet nyújtana?<span
          class="text-danger"
          >*</span
        >&nbsp;
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="claim_future"
            :value="1"
            v-model="claim_future"
          />
          <label class="form-check-label" for="claim_future">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="claim_future"
            :value="0"
            v-model="claim_future"
          />
          <label class="form-check-label" for="claim_future">
            Nem
          </label>
        </div>
      </div>
      <ValidationProvider
        v-show="false"
        :immediate="true"
        rules="required"
        class="col-sm-8"
      >
        <input
          id="claim_future"
          class="form-check-input"
          type="radio"
          v-model="claim_future"
        />
      </ValidationProvider>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >A szerződő jelenleg rendelkezik élő Tervezői és Mérnöki Szakmai
        Felelősségbiztosítás a Colonnade Insurance S.A. Magyarországi
        Fióktelepénél?<span class="text-danger">*</span>&nbsp;
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="contract_exists"
            :value="1"
            v-model="contract_exists"
          />
          <label class="form-check-label" for="contract_exists">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="contract_exists"
            :value="0"
            v-model="contract_exists"
          />
          <label class="form-check-label" for="contract_exists">
            Nem
          </label>
        </div>
      </div>
      <ValidationProvider
        v-show="false"
        :immediate="true"
        rules="required"
        class="col-sm-8"
      >
        <input
          id="contract_exists"
          class="form-check-input"
          type="radio"
          v-model="contract_exists"
        />
      </ValidationProvider>
    </div>
    <div>
      <h1>Biztosítási fedezet:</h1>
      Milyen károk esetében térít a szakmai felelősségbiztosítási fedezet?
      <a
        target="”_blank”"
        href="https://www.colonnade.hu/media/tervezok-mernokok-szakmai-felelossegbiztositas-karpeldak"
        >Példák</a
      ><br /><br />
    </div>
    <div class="mb-3">
      <h2>Alap szakmai felelősségbiztosítási fedezet</h2>
      <ol>
        <li>
          <b style="color: #e4002b;"
            >Szakmai felelősség személyi sérüléses és dologi károk fedezet:<br
          /></b>
          Szakmai Tervezési, mérnöki szakmai tevékenységek folytatása során
          elkövetett szakmai műhibából eredő személyi és dologi károk, illetve
          sérelemdíjak fedezete.
        </li>
        <li>
          <b style="color: #e4002b;">
            Jogi védelmi költségek fedezet
          </b>
        </li>
      </ol>
    </div>
    <div class="mb-3">
      Kérjük jelölje, ha szeretné az alábbiakkal kiegészíteni a biztosítási
      fedezetet.
    </div>
    <h2>Kiegészítő fedezetek</h2>
    <div v-if="financial_losses" class="mb-3" style="color: red;">
      Amennyiben nem szeretne Pénzügyi Károk térítése fedezetet igényelni, vegye
      ki a jelölést a fedezet elől!
    </div>
    <div class="form-check mb-2">
      <ValidationProvider name="financial_losses" rules="" :immediate="true">
        <input
          type="checkbox"
          class="form-check-input"
          id="financial_losses"
          v-model="financial_losses"
        />
      </ValidationProvider>
      <input
        v-show="false"
        name="financial_losses"
        :value="financial_losses ? 1 : 0"
      />
      <label for="financial_losses" class="form-check-label">
        <b style="color: #e4002b;">
          Pénzügyi Károk térítése fedezet- Szakmai felelősség tisztán pénzügyi
          veszteségek fedezet
        </b>
      </label>
      &nbsp;
      <span
        class="info"
        id="financial_losses-tooltip"
        data-toggle="tooltip"
        data-placement="right"
        title=""
      >
        ?</span
      >
      <ul>
        <li>Személyhez fűződő jogok megsértése fedezet</li>
        <li>Szellemi alkotáshoz fűződő jogok megsértése fedezet</li>
        <li>Internettel kapcsolatos felelősség fedezet</li>
      </ul>
    </div>
    <div class="form-group sm-2 row">
      <label class="col-sm-4" for="begin_date"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="col-sm-4">
        <Datepicker
          id="begin_date"
          name="begin_date"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="riskStartDisabledDates"
          :typeable="false"
          input-class="form-control"
          required
          v-model="startDate"
        ></Datepicker>
        <ValidationProvider
          :immediate="true"
          rules="required|kockazat_kezdet"
          v-slot="{ errors }"
        >
          <input
            type="text"
            name="begin_date"
            :value="startDate"
            disabled
            hidden
          />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div class="form-check mb-2">
      <ValidationProvider name="extended_claim" rules="" :immediate="true">
        <input
          type="checkbox"
          class="form-check-input"
          id="extended_claim"
          v-model="extended_claim"
        />
      </ValidationProvider>
      <input
        v-show="false"
        name="extended_claim"
        :value="extended_claim ? 1 : 0"
      />
      <label for="extended_claim" class="form-check-label">
        <b>
          Kiterjesztett kárbejelentési időszak fedezet
        </b>
      </label>
      &nbsp;
      <span
        class="info"
        id="extended_claim-tooltip"
        data-toggle="tooltip"
        data-placement="right"
        title=""
      >
        ?</span
      >
      <span v-if="merchant_id === 'eurosales'"
        >1 év automatikus kiterjesztett kárbejelentési időszak fedezetet
        tartalmaz
      </span>
    </div>
    <div v-if="extended_claim" class="form-group row mb-3">
      <!-- <div v-if="process === 'NORMAL' || process === 'EGYEDI'" class="form-group row mb-3"> -->
      <!-- <label class="col-sm-4" for="kiterjesztett_ev"
        >Kérjük adja meg a Biztosított nettó árbevételét!:<span class="text-danger">*</span>
      </label> -->
      <div class="col-sm-4">
        <div>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            class="col-md-6 mb-3"
          >
            <select
              class="form-select"
              id="extended_claim_year"
              name="extended_claim_year"
              v-model="chosenExtendedClaim"
              required
            >
              <option value="Kérem, válasszon!" selected disabled
                >Kérem, válasszon!</option
              >
              <option
                v-for="(value, key) in extendedEv"
                :key="key"
                :value="key"
                >{{ value }}</option
              >
            </select>
            <small
              id="ph_contact_lastname-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div class="form-check mb-2">
      <ValidationProvider
        name="retroactive_coverage"
        rules=""
        :immediate="true"
      >
        <input
          type="checkbox"
          class="form-check-input"
          id="retroactive_coverage"
          v-model="retroactive_coverage"
        />
      </ValidationProvider>
      <input
        v-show="false"
        name="retroactive_coverage"
        :value="retroactive_coverage ? 1 : 0"
      />
      <label for="retroactive_coverage" class="form-check-label">
        <b>
          Visszamenőleges hatály fedezet
        </b> </label
      >&nbsp;
      <span
        class="info"
        id="retroactive_coverage-tooltip"
        data-toggle="tooltip"
        data-placement="right"
        title=""
      >
        ?</span
      >
      <span v-if="merchant_id === 'eurosales'"
        >1 év automatikus visszamenőleges fedezetet tartalmaz</span
      >
    </div>
    <div v-if="retroactive_coverage" class="form-group row mb-3">
      <!-- <div v-if="process === 'NORMAL' || process === 'EGYEDI'" class="form-group row mb-3"> -->
      <!-- <label class="col-sm-4" for="retro_ev"
        >Kérjük adja meg a Biztosított nettó árbevételét!:<span class="text-danger">*</span>
      </label> -->
      <div class="col-sm-4">
        <div>
          <ValidationProvider
            rules="required"
            v-slot="{ errors }"
            class="col-md-6 mb-3"
          >
            <select
              class="form-select"
              id="retroactive_coverage_year"
              name="retroactive_coverage_year"
              v-model="chosenRetroactiveCoverage"
              required
            >
              <option value="Kérem, válasszon!" selected disabled
                >Kérem, válasszon!</option
              >
              <option v-for="(value, key) in retroEv" :key="key" :value="key">{{
                value
              }}</option>
            </select>
            <small
              id="ph_contact_lastname-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div v-if="retroactive_coverage" class="form-group row mb-3">
      <label class="col-sm-4" for="retro_date"
        >Visszamenőleges hatály dátum:
      </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          id="retro_date"
          name="retro_date"
          :value="retro_date"
          readonly
        />
      </div>
    </div>
    <div class="form-group sm-2 row">
      <label class="col-sm-6"
        ><b>Önrészesedés:</b>10% min 35.000 Ft / káresemény
      </label>
      <div class="col-sm-8">
        <ValidationProvider :immediate="true" rules="" v-slot="{ errors }">
          <div v-if="financial_losses">
            Tisztán pénzügyi károkra vonatkozóan 10% min 100.000 Ft / káresemény
          </div>
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div><b>Területi hatály:</b> Magyarország</div>
    <!-- <div v-if="extended_claim" class="form-group row mb-3">
      <label class="col-sm-4" for="extclaim_date"
        >Kiterjesztett kárbejelentési időszak fedezet dátum:
      </label>
      <div class="col-sm-4">
        <input
          class="form-control"
          id="extclaim_date"
          name="extclaim_date"
          :value="extclaim_date"
          readonly
        />
      </div>
    </div> -->
    <h1 class="h2 mt-4">Díjfizetés</h1>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <b
          >Díjfizetési mód <span class="text-danger">*</span>&nbsp;
          <span
            class="info"
            id="payment_way-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></b
        >
      </div>
      <div class="col-sm-8 row">
        <input type="text" hidden v-model="paymentType" name="payment_way" />
        <div class="col-md-4 form-group mb-2">
          <div
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'banktransfer'"
            :class="{
              'btn-red': paymentType == 'banktransfer',
              'btn-outline-danger': paymentType !== 'banktransfer',
            }"
          >
            Banki átutalás
          </div>
        </div>
        <div class="col-md-4 form-group mb-2">
          <div
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'online'"
            :class="{
              'btn-red': paymentType == 'online',
              'btn-outline-danger': paymentType !== 'online',
            }"
          >
            Online bankkártyás
          </div>
        </div>
      </div>
      <small id="payment_way-error" class="text-danger input-alert"></small>
    </div>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <b
          >Díjfizetési gyakoriság <span class="text-danger">*</span>&nbsp;
          <span
            class="info"
            id="payment_frequency-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></b
        >
      </div>
      <div class="col-sm-8 row">
        <input
          type="text"
          hidden
          v-model="paymentFrequency"
          name="payment_frequency"
        />
        <div class="col-md-4 form-group mb-2">
          <div
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentFrequency = 'yearly'"
            :class="{
              'btn-red': paymentFrequency == 'yearly',
              'btn-outline-danger': paymentFrequency !== 'yearly',
            }"
          >
            Éves
          </div>
        </div>
      </div>
      <small
        id="payment_frequency-error"
        class="text-danger input-alert"
      ></small>
    </div>
    <div class="form-check">
      <ValidationProvider name="period_discount" rules="" :immediate="true">
        <input
          type="checkbox"
          class="form-check-input"
          id="period_discount"
          v-model="period_discount"
        />
      </ValidationProvider>
      <input
        v-show="false"
        name="period_discount"
        :value="period_discount ? 1 : 0"
      />
      <label for="period_discount" class="form-check-label">
        <b>
          Szeretne tartamkedvezményre vonatkozó 10% díjcsökkentést alkalmazni?
        </b>
      </label>
      &nbsp;
      <span
        class="info"
        id="period_discount-tooltip"
        data-toggle="tooltip"
        data-placement="right"
        title=""
      >
        ?</span
      >
    </div>
    <br />
    <SIDCode></SIDCode>
    <overall-data></overall-data>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
import { mapFields } from "vuex-map-fields";
import Select2 from "v-select2-component";
import OverallData from "./components/OverallData";
import { ValidationProvider } from "vee-validate";
import { hu } from "vuejs-datepicker/dist/locale";
import SIDCode from "./components/SIDCode.vue";

export default {
  components: {
    Datepicker,
    Select2,
    OverallData,
    SIDCode,
  },
  data() {
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1
    );
    const minDate = new Date();
    const tomorrow = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1
    );
    minDate.setFullYear(today.getFullYear() - 80);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDateIns = new Date();
    maxDateIns.setFullYear(today.getFullYear() - 12);
    maxDateIns.setMonth(now.getMonth());
    maxDateIns.setDate(now.getDate());
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());
    return {
      hu: hu,
      karOpened: false,
      szerzodesOpened: false,
      iparagOpened: false,
      amerikaOpened: false,
      oroszorszagrOpened: false,
      riskStartDisabledDates: {
        customPredictor: function(date) {
          // if (date < new Date('2025.01.01')) return true;
          const maxDate = new Date().setDate(now.getDate() + 60);
          return date < now || date > maxDate;
        },
        // customPredictor: function(date) {
        //   const earliestDate = new Date(2025, 0, 15);

        //   let maxDate;
        //   let startDate;

        //   if (now < earliestDate) {
        //     startDate = earliestDate;
        //   } else {
        //     startDate = tomorrow;
        //   }

        //   startDate = earliestDate;
        //   maxDate = new Date(new Date(now).setDate(now.getDate() + 60));
        //   return date < startDate || date > maxDate;
        // },
      },
    };
  },
  computed: {
    ...mapFields([
      "design_buildings",
      "design_machine",
      "prof_engineer",
      "prof_engineer_other",
      "detailed_engineer",
      "detailed_manager",
      "detailed_project",
      "prof_engineer_other_type",
      "technical_inspection",
      "legal_expert",
      "certify_audit",
      "design_inspector",
      "techn_management",
      "investment_manager",
      "construction",
      "manufacture",
      "legal_compliance",
      "claim_history",
      "claim_future",
      "contract_exists",
      "financial_losses",
      "extended_claim",
      "retroactive_coverage",
      "retro_ev",
      "kiterjesztett_ev",
      "chosenExtendedClaim",
      "chosenRetroactiveCoverage",
      "merchant_id",
      "retro_date",
      "extclaim_date",
      "startDate",
      "detailed_project_statement",
      "detailed_engineer_statement",
      "period_discount",
    ]),
    ...mapFields({
      paymentType: "paymentOptions.type",
      paymentFrequency: "paymentOptions.frequency",
      statements_kar: "statements.kar",
      statements_szerzodes: "statements.szerzodes",
      statements_iparag: "statements.iparag",
      statements_amerika: "statements.amerika",
      statements_oroszorszag: "statements.oroszorszag",
    }),
    ...mapGetters({
      datas: "getAllState",
      getListChosen: "getListChosen",
    }),
    getDetailedEngineerChosen() {
      return this.getListChosen("detailed_engineer_checked");
    },
    getDetailedManagerChosen() {
      return this.getListChosen("detailed_manager_checked");
    },
    getDetailedProjectChosen() {
      return this.getListChosen("detailed_project_checked");
    },

    retroEv() {
      if (this.$store.state.merchant_id !== "eurosales") {
        return this.$store.state.retro_ev;
      } else {
        const retroEvFiltered = Object.fromEntries(
          Object.entries(this.$store.state.retro_ev).filter(
            ([key]) => key !== "t1"
          )
        );
        return retroEvFiltered;
      }
    },
    extendedEv() {
      if (this.$store.state.merchant_id !== "eurosales") {
        return this.$store.state.kiterjesztett_ev;
      } else {
        const extendedEvFiltered = Object.fromEntries(
          Object.entries(this.$store.state.kiterjesztett_ev).filter(
            ([key]) => key !== "t1"
          )
        );
        return extendedEvFiltered;
      }
    },
    IsDetailedEngineerChosen() {
      if (
        this.detailed_engineer_statement ||
        this.getListChosen("detailed_engineer_checked").length > 0
      )
        return "chosen";
      else return "";
    },
    IsDetailedProjectChosen() {
      if (
        this.detailed_project_statement ||
        this.getListChosen("detailed_project_checked").length > 0
      )
        return "chosen";
      else return "";
    },
    IsProfessionalActivityChosen() {
      if (
        this.design_buildings ||
        this.prof_engineer ||
        this.legal_expert ||
        this.prof_engineer_other ||
        this.technical_inspection ||
        this.certify_audit ||
        this.design_inspector ||
        this.techn_management ||
        this.investment_manager
      )
        return "chosen";
      else return "";
    },
  },

  watch: {
    design_buildings() {
      if (!this.design_buildings && !this.prof_engineer) {
        this.$store.commit("setDetailedEngineerStatement", null);
        Object.keys(this.detailed_engineer).forEach((key) => {
          this.$store.commit("updateListByName", {
            listName: "detailed_engineer_checked",
            id: key,
            value: false,
          });
        });
      }
    },
    prof_engineer() {
      if (!this.design_buildings && !this.prof_engineer) {
        this.$store.commit("setDetailedEngineerStatement", null);
        Object.keys(this.detailed_engineer).forEach((key) => {
          this.$store.commit("updateListByName", {
            listName: "detailed_engineer_checked",
            id: key,
            value: false,
          });
        });
      }
    },
    detailed_engineer_statement() {
      console.log(this.isDetailedEngineerChecked);
      if (this.detailed_engineer_statement) {
        Object.keys(this.detailed_engineer).forEach((key) => {
          this.$store.commit("updateListByName", {
            listName: "detailed_engineer_checked",
            id: key,
            value: false,
          });
        });
      }
    },
    investment_manager() {
      if (this.investment_manager) {
        Object.keys(this.detailed_manager).forEach((key) => {
          this.$store.commit("updateListByName", {
            listName: "detailed_manager_checked",
            id: key,
            value: false,
          });
        });
      }
    },
    detailed_project_statement() {
      if (this.detailed_project_statement) {
        Object.keys(this.detailed_project).forEach((key) => {
          this.$store.commit("updateListByName", {
            listName: "detailed_project_checked",
            id: key,
            value: false,
          });
        });
      }
    },
    extended_claim() {
      if (!this.extended_claim) {
        this.$store.commit("setchosenExtendedClaim", null);
      }
    },
    retroactive_coverage() {
      if (!this.retroactive_coverage) {
        this.$store.commit("setchosenRetroactiveCoverage", null);
      }
    },
  },
  methods: {
    ...mapActions(["verifyPage", "EmailValidationCode"]),
    karClick(e) {
      if (e) e.preventDefault();
      this.karOpened = !this.karOpened;
    },
    szerzodesClick(e) {
      if (e) e.preventDefault();
      this.szerzodesOpened = !this.szerzodesOpened;
    },
    iparagClick(e) {
      if (e) e.preventDefault();
      this.iparagOpened = !this.iparagOpened;
    },
    amerikaClick(e) {
      if (e) e.preventDefault();
      this.amerikaOpened = !this.amerikaOpened;
    },
    oroszorszagClick(e) {
      if (e) e.preventDefault();
      this.oroszorszagrOpened = !this.oroszorszagrOpened;
    },
    isDetailedEngineerChecked(listName, id) {
      return this.$store.state[listName][id];
    },
    updateCheckeddDtailedEngineer(listName, id, value) {
      this.$store.commit("updateListByName", { listName, id, value });
    },
  },
  created: function() {
    if (!this.$store.state.email_valid_code) this.EmailValidationCode();
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;
.custom-file-label::after {
  content: "Kiválasztás" !important;
}

.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select2-selection__arrow {
  height: 38px !important;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
